{
  "services-mobile-top-ups-dynamic": {
    "meta": {
      "title": "Send mobile top-ups to {country} - MAJORITY",
      "description": "Send no-fee mobile top-ups to {country}! Instant, secure delivery."
    },
    "hero": {
      "title": "Send mobile top-ups to {country}",
      "body": "We’re currently working hard to bring you no-fee top-ups to {country}. Check back again soon.",
      "cta": "See more countries"
    },
    "generic": {
      "meta": {
        "title": "Send mobile top-ups to {country}",
        "description": "Send no-fee mobile top-ups to {country}! Instant, secure delivery."
      },
      "hero": {
        "title": "Send mobile top-ups to {country}",
        "body": "Share credits with loved ones back home, fee-free!",
        "cta": "Get started",
        "cta_1": "See more countries"
      },
      "no_fee_content_box": {
        "tagline": "Mobile top-ups",
        "title": "Top up to {country} fee-free",
        "body": "Stay in touch with friends and family in {country}! Send mobile top-ups to any cell phone in {country} without being charged additional fees. Plus, our instant, secure delivery makes it so that you don't miss a second catching up.",
        "cta": "Get started",
        "canvas": "Save and send more"
      },
      "whats_recarga_content_box": {
        "tagline": "Mobile top-ups",
        "title": "What are mobile top-ups?",
        "body": "Mobile top-ups, sometimes referred to as airtime or recargas, allow you to send credits to your friends and family in {country}. Credits are sent USD and are received in the local currency to be used to make calls, send texts, and more.",
        "cta": "Get started"
      },
      "how_to_content_box": {
        "tagline": "Mobile top-ups",
        "title": "How to send mobile top-ups to {country}",
        "body": "The best way to send top-ups to {country} is with the MAJORITY app. Simply open the app and follow these instructions to get started.\n+ Select “Send” at the bottom of the screen\n+ Press “Mobile top-up”\n+ Select who you’d like to send mobile top-ups to in {country}\n+ Choose the amount you’d like to send in USD\n+ Send!",
        "cta": "Get started"
      },
      "faq": {
        "title": "FAQ",
        "faqs": [
          {
            "question": "Can I use MAJORITY if I’m not a migrant?",
            "answer": "Yes! Everyone is welcome. If any of the features in our app interest you, sign up and give it a try."
          },
          {
            "question": "Is MAJORITY a bank?",
            "answer": "We are a financial membership app providing banking services through our partner, Axiom Bank, N.A., Member FDIC. The signature MAJORITY Visa® debit card is also issued by Axiom Bank pursuant to a license from Visa U.S.A. Inc. The card can be used anywhere Visa is accepted!"
          },
          {
            "question": "What is MAJORITY?",
            "answer": "MAJORITY is the first-ever financial membership built by migrants, for migrants. After signing up, you get an FDIC-insured account with no overdraft fees, a Visa® Debit Card, fee-free money transfers, free and low-cost international calls, and more!"
          },
          {
            "question": "Where is MAJORITY?",
            "answer": "We have offices in Houston, Miami, and Stockholm, Sweden.Visit us at MAJORITY Meetup Houston, located in 9801 V Bissonnet Street, Houston, Texas 77036, United States."
          },
          {
            "question": "Will my money be safe with MAJORITY?",
            "answer": "Absolutely. Your MAJORITY account is FDIC-insured, so whether you are in the US or abroad, the money in your account is protected up to $250,000 by the FDIC. Plus, you’ll be able to access your app anywhere, so there’s nothing to worry about."
          }
        ]
      }
    }
  }
  
}